<template>
  <div class="login-container" @keyup.enter="handleLogin">
    <div class="bg"></div>
    <div class="form-box">
      <el-form :model="dataForm" :rules="dataRule" ref="loginDataForm" class="login-form" autoComplete="on"
              label-position="left">
        <div class="title-container">
          <div class="logo"><img src="../../assets/images/logo-02.png"></div>
          <div class="title-text">产品追溯系统管理后台</div>
        </div>
        <el-form-item prop="companyCode">
          <i class="icon el-icon-company" style="vertical-align:baseline;color:#b1b1b1"></i>
          <el-input v-model="dataForm.companyCode" type="text" autoComplete="on"
                    placeholder="请输入公司编号"/>
        </el-form-item>
        <el-form-item prop="account">
          <i class="icon icon-account"></i>
          <el-input v-model="dataForm.account" type="text" autoComplete="on"
                    placeholder="请输入账号"/>
        </el-form-item>
        <el-form-item prop="password">
          <i class="icon icon-password"></i>
          <el-input v-model="dataForm.password" type="password" autoComplete="on"
                    placeholder="请输入密码"/>
        </el-form-item>
        <!-- <div @click="forgetPassword" class="forget">忘记密码？</div> -->
        <el-button class="btn-login" @click.native.prevent="handleLogin">登录</el-button>
      </el-form>
      <div style="position: absolute; bottom: 30px;"><a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #9b9b9b; font-size: 14px;" target="_blank">上海森昶网络科技有限公司 版本V1.0 沪ICP备2020027748号-1</a></div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
  import { menuDataTranslate } from '../../utils/common'
  import { mapGetters, mapMutations } from 'vuex'
  import { apiLogin } from '../../api/user'

  export default {
    name: 'login',
    data() {
      return {
        dataForm: {
          companyCode: '',
          account: '',
          password: ''
        },
        dataRule: {
          companyCode: [
            { required: true, message: '公司编号不能为空', trigger: 'blur' }
          ],
          account: [
            { required: true, message: '账号不能为空', trigger: 'blur' }
          ],
          password: [
            { required: true, message: '密码不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    created() {
      this.dataForm.companyCode = localStorage.getItem('companyCode') || ''
      this.dataForm.account = localStorage.getItem('account') || ''
    },
    computed: {
      ...mapGetters([
        'menuList'
      ])
    },
    methods: {
      handleLogin() {
        this.$refs['loginDataForm'].validate((valid) => {
          if (valid) {
            apiLogin(this.dataForm.companyCode, this.dataForm.account, this.dataForm.password).then(({ data }) => {
              if (data === null) { return }
              if (data.type === 1) {
                data.companyList.unshift(data.organization)
                data.companyIds = data.organization.id + ''
              }
              sessionStorage.setItem('userInfo', JSON.stringify(data))
              this.setUserInfo(data)
              let moduleList = data.role.moduleList
              this.setMenuList(moduleList)
              this.setRoles(moduleList)
              sessionStorage.setItem('moduleList', JSON.stringify(moduleList))
              localStorage.setItem('companyCode', this.dataForm.companyCode)
              localStorage.setItem('account', this.dataForm.account)
              window.location.href = process.env.VUE_APP_BASE_URL + 'index'
            })
          }
        })
      },
      forgetPassword() {
        this.$alert('请在企业微信中联系曾凡辉重置密码。', '提示', {
          confirmButtonText: '确认'
        })
      },
      ...mapMutations({
        setMenuList: 'SET_MENU_LIST',
        setUserInfo: 'SET_USERINFO',
        setRoles: 'SET_ROLES'
      })
    }
  }
</script>

<style lang="stylus">
  .login-container
    .clear
      clear both
    .bg
      position relative
      width 60%
      height 100vh
      background-image url("../../assets/images/bg.jpg")
      background-size 100%
      float left
    .form-box
      position relative
      float left
      display flex
      align-items center
      justify-content center
      background-color #ffffff
      width 40%
      height 100vh
      .el-input
        display inline-block
        height 50px
        width 85%
        input
          background: transparent
          border 0px
          -webkit-appearance none
          border-radius 0
          padding 15px 5px
          color #9b9b9b
          height 50px
          font-size 14px !important
          &:-webkit-autofill,
          &:-webkit-autofill:hover,
          &:-webkit-autofill:focus,
          &:-webkit-autofill:active
            -webkit-box-shadow 0 0 0 100px #fff inset !important
          &:-webkit-autofill
            -webkit-box-shadow 0 0 0 100px #fff inset !important
            -webkit-text-fill-color #9b9b9b !important
      .el-form-item
        border 1px solid #EEEEEE
        background #FCFDFF
        border-radius 5px
        color #454545
        .el-form-item__error
          margin-left 36px
      .login-form
        width 65%
        height 400px
        margin auto
        position absolute
        top 0
        bottom 0
        left 0
        right 0
        .title-container
          position relative
          .logo
            margin 0 auto
            margin-bottom 10px
            width 20%
            img
              width 100%
          .title-text
            font-size 24px
            font-weight bold
            text-align center
            margin-bottom 20px
        .icon
          display inline-block
          vertical-align sub
          width 14px
          height 16px
          margin-left 15px
          background-size 100%
          &.icon-account
            background url("../../assets/images/account.png") no-repeat center
          &.icon-password
            background url("../../assets/images/password.png") no-repeat center
        .forget
          color #a1a7a8
          text-align right
          margin-bottom 10px
          cursor pointer
        .btn-login
          font-size 17px
          width 100%
          margin-bottom: 30px
          color #ffffff
          border-radius 5px
          background #A5CE1C
          padding 15px 10px
</style>
